import { styled } from '@mui/material';
import { NotificationChip, menuItemStyles } from '../styles';
import { NotificationContext, NotificationLabelProps } from '../types';

export const NotificationLabel: React.FC<NotificationLabelProps> = ({
  label,
  count,
  shouldShowNotification,
  context = 'navbar',
  dataTestId,
  isSelected,
}) => {
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <StyledLabel context={context} isSelected={isSelected}>
        {label}
      </StyledLabel>
      {shouldShowNotification && (
        <NotificationChip
          data-testid={`${dataTestId}-notification-chip`}
          label={context === 'tabs' ? count.toString() : `${count} new`}
          size="small"
          color="primary"
          sx={context === 'tabs' ? notificationChipStyles.tabs : undefined}
        />
      )}
    </span>
  );
};

const StyledLabel = styled('span', {
  shouldForwardProp: (prop) => prop !== 'context' && prop !== 'isSelected',
})<{ context: NotificationContext; isSelected?: boolean }>(({ theme, context, isSelected }) => ({
  ...(context === 'tabs' && {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    fontSize: theme.typography.subtitle.fontSize,
    fontStyle: 'normal',
    fontWeight: isSelected ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular,
    lineHeight: '28px',
  }),
  ...(context === 'navbar' && {
    ...menuItemStyles(theme),
  }),
}));

const notificationChipStyles = {
  tabs: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    '& .MuiChip-label': {
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
};
